// client\src\App.jsx

import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CallProvider, useCallContext } from './contexts/CallContext';
import AppLayout from './layouts/AppLayout';
import Footer from './components/common/Footer';
import './App.css';

const Login = lazy(() => import('./pages/Login'));
const HomePage = lazy(() => import('./pages/HomePage'));

const LoadingFallback = () => (
  <div className="flex items-center justify-center p-8 min-h-screen">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  </div>
);

function LoginRoute() {
  const { isAuthenticated, handleLoginSuccess } = useCallContext();
  if (isAuthenticated) return <Navigate to="/" replace />;
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Login onLoginSuccess={handleLoginSuccess} />
    </Suspense>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CallProvider>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route element={<AppLayout />}>
              <Route index element={<HomePage />} />
              <Route path="dashboard" element={<HomePage />} />
            </Route>
            <Route path="/footer" element={<Footer />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </CallProvider>
    </BrowserRouter>
  );
}

export default App;